import { css } from '@emotion/react'
import styled from '@emotion/styled'

/**
 * RC01: um painel por conta, sempre na mesma linha, dividindo a largura disponível — sem barra de
 * rolagem. Sem `overflow`, o tooltip também escapa livremente da linha.
 */
export const ChartsRow = styled.div`
  ${() => css`
    display: flex;
    align-items: flex-end;
    gap: 8px;
    padding-bottom: 16px;
  `}
`

export const LegendContainer = styled.div`
  ${() => css`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px 24px;
    margin-top: 24px;
  `}
`

export const LegendItem = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 8px;
  `}
`

export const LegendColorBox = styled.div<{ color: string }>`
  ${({ color }) => css`
    width: 16px;
    height: 16px;
    background-color: ${color};
    border-radius: 50%;
    flex-shrink: 0;
  `}
`

export const LegendLabel = styled.span`
  ${() => css`
    font-size: 14px;
    color: #333;
    white-space: nowrap;
  `}
`
